import React from 'react';
import RequireAuth from './RequireAuth.jsx';

const RequireAdmin = ({ children }) => <RequireAuth roles={['admin']}>{children}</RequireAuth>;

export default RequireAdmin;
